import { useZxing } from "react-zxing";


//{
//  onResult: (decodedText, result) => {}
//}
export const QRCodeScanner = (props) => {

  const { ref } = useZxing({
    //onResult(result) {
     // props.onResult(result.getText(),result);  
    //},
    onDecodeResult(result) {
      props.onResult(result.getText(),result);  
    },
    timeBetweenDecodingAttempts: 50,
    constraints: {
      video: {
        frameRate: 30,
        focusMode: 'continuous', // exists on some browsers
        autoGainControl: true,
        noiseSuppression: true,
        advanced: [{ zoom: 2.0 }],// exists on some browsers
        aspectRatio: 1,
        //facingMode: 'environment',
        facingMode: {exact:'environment'},
      }
    }

  });

  return (
    <>
      <video  width='100%' height={'auto'} ref={ref} />
    </>
  );

}   